/** Route paths for the Tests module (relative to module base path) */
export const TESTS_ROUTES = {
  MCTS: "mcts",
  CYOT: "cyot",
  ILTS: "ilts",
  PYPS: "pyps",
  CWTS: "cwts",
  SCORE: "score",
  SCORE_REGISTER: "score/register",
  SCORE_MIND_MAPS: "score/mind-maps",
  SCORE_FORMULA_SHEETS: "score/formula-sheets",
  REVISION_TEST: "revision-tests",
  DETAIL: "page2",
  GENERAL_INSTRUCTIONS: "general-instructions",
  EXAM: "exam",
  TEST_FINISH: "test-finish",
  SOLUTIONS: "solutions",
  SUBJECTIVE_SOLUTIONS: "subjective-solutions",
  UPLOAD_ANSWER_SHEET: "upload-answer-sheet",
  UPLOAD_ANSWER_PDF: "upload-answer-pdf",
  PDF_PREVIEW: "pdf-preview",
  REPORT: "report",
  CALCULATION_SCORE: "calculation-score",
  WIZKLUB: "wizklub",
  GENIUS_ASSESSMENT_STARTING_SOON: "genius-assessment-starting-soon",
  GENIUS_ASSESSMENT_NOT_AVAILABLE: "genius-assessment-not-available",
} as const;
